export default "__VITE_ASSET__BjqBRRVr__"